/**
 * @ComponentFor Avensia.Scope.ServerRenderedHtmlPage
 */
import ServerRenderedHtmlBlock from './ServerRenderedHtmlBlock';

export default class ServerRenderedHtmlPage extends ServerRenderedHtmlBlock<Scope.ServerRenderedHtmlPage> {}
